module.exports = __webpack_public_path__ + "img/zrinjski-kopirnica.7938854e.png";